import { action, makeObservable, observable } from 'mobx';

import ApiService from '../services/ApiService';

import { InvoiceSettingsChangeLog } from './models/InvoiceSettingsChangeLog';
import { Loadable } from './models/Loadable';
import { ISsoStore } from './SsoStore';

export default class InvoiceSettingsChangeLogStore {
  @observable
  public changeLog: Loadable<InvoiceSettingsChangeLog> = new Loadable<InvoiceSettingsChangeLog>();

  constructor(
    private apiService: ApiService,
    private ssoStore: ISsoStore
  ) {
    makeObservable(this);
  }

  @action
  public async loadChangeLog(referenceNumber: string, source: string): Promise<any> {
    const promise = this.apiService.getInvoiceSettingsChangeLog(this.ssoStore.customer.customerId, referenceNumber, source);
    this.changeLog = Loadable.toLoadable(promise);
    await promise;
  }
}
